import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { callAllHandlers } from "@smartsheet/lodestar-utils";
import { useMemo, useState } from "react";
export var useHovered = function useHovered() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    providedOnMouseEnter = _ref.onMouseEnter,
    providedOnMouseLeave = _ref.onMouseLeave;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var onMouseEnter = useMemo(function () {
    return callAllHandlers(providedOnMouseEnter, function () {
      setIsHovered(true);
    });
  }, [providedOnMouseEnter]);
  var onMouseLeave = useMemo(function () {
    return callAllHandlers(providedOnMouseLeave, function () {
      setIsHovered(false);
    });
  }, [providedOnMouseLeave]);
  var result = {
    isHovered: isHovered,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
  return result;
};
//# sourceMappingURL=useHovered.js.map